import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {useLocalImage} from '@app/hooks/use-local-image';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {useLocation} from '@app/hooks/use-location';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: 'b4d6cab7e01363de35e345f62089af16.png',
	fr: '97b63ef85eaaa7004c67062c5f6e2073.png',
};

export const Satisfaction: FunctionComponent = () => {
	const {t} = useTranslation({ns: ['reviews', 'common']});

	const {getDeezerUrl} = useLocation();
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			imagePosition="left"
			description={
				<>
					<LandingHeading as="h2">
						{t('reviewslandingpage_title_seewhatdzrhastooffer_standalone-web')}
					</LandingHeading>

					<LandingParagraph
						dangerouslySetInnerHTML={{
							__html: t(
								'reviewslandingpage_text_seewhatdzrhastooffer1_standalone-web',
								{
									sprintf: [
										`href=${getDeezerUrl('/offers/premium')}`,
										`href=${getDeezerUrl('/offers/family')}`,
										`href=${getDeezerUrl('/offers/student')}`,
										`href=${getDeezerUrl('/offers/free')}`,
										`href=${getDeezerUrl('/offers')}`,
									],
								},
							),
						}}
					/>

					<LandingParagraph
						dangerouslySetInnerHTML={{
							__html: t(
								'reviewslandingpage_text_seewhatdzrhastooffer2_standalone-web',
								{
									sprintf: [
										`href=${'https://apps.apple.com/app/deezer-music-player-podcast/id292738169'}`,
										`href=${'https://play.google.com/store/apps/details?id=deezer.android.app'}`,
										`href=${'https://fr.deezercommunity.com/'}`,
									],
								},
							),
						}}
					/>
				</>
			}
			image={
				<Image
					aspectRatio="2160/1260"
					sizes={{base: '100vw', md: '50vw'}}
					h={{base: '250px', md: '100%'}}
					src={src}
					alt={t(
						'reviewslandingpage_title_seewhatdzrhastooffer_standalone-web',
						{},
					)}
				/>
			}
			cta={
				<LandingButtonLink
					href={getDeezerUrl('/offers')}
					tracking={{
						eventcategory: 'review',
						eventaction: 'discover',
						eventlabel: 'offers',
					}}
				>
					{t('generic_action_seeallplans_standalone-web')}
				</LandingButtonLink>
			}
		/>
	);
};
